import Vue from "vue";
import Layout from "@/layout";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};

Vue.use(VueRouter);

const routes = [
  {
    path: "/login",
    name: "login",
    component: () => import("@/views/login/index"),
    meta: {
      title: "登录",
    },
  },
  {
    path: "/register",
    name: "register",
    component: () => import("@/views/register/index"),
    meta: {
      title: "立即注册",
    },
  },
  {
    path: "/forgot-password",
    name: "forgotPassword",
    component: () => import("@/views/forgotPassword/index"),
    meta: {
      title: "忘记密码",
    },
  },
  {
    path: "/",
    component: Layout,
    children: [
      {
        path: "",
        component: Home,
        name: "Home",
        meta: {
          title: "首页",
          showFooter: true,
          showHeader: true,
        },
      },
      {
        path: "bannerDetail",
        component: () => import("@/views/home/HomebannerDetail.vue"),
        name: "BannerDetail",
        meta: {
          title: "banner详情",
          showFooter: true,
          showHeader: true,
        },
      },
      {
        path: "procurement",
        component: () => import("@/views/procurement/index"),
        name: "Procurement",
        meta: {
          title: "招采中心",
          showFooter: true,
          showHeader: true,
        },
        children: [
          {
            path: "procurementDeal",
            component: () => import("@/views/procurement/procurementDeal.vue"),
            name: "ProcurementDeal",
            meta: {
              title: "填写招采单",
              showFooter: true,
              showHeader: true,
            },
          },
          {
            path: "procurementDetail",
            component: () =>
              import("@/views/procurement/procurementDetail.vue"),
            name: "ProcurementDetail",
            meta: {
              title: "招采详情",
              showFooter: true,
              showHeader: true,
            },
          },
        ],
      },
      {
        path: "wantBuy",
        component: () => import("@/views/wantBuy/index"),
        name: "WantBuy",
        meta: {
          title: "求购中心",
          showFooter: true,
          showHeader: true,
        },
        children: [
          {
            path: "buyDeal",
            component: () => import("@/views/wantBuy/buyDeal.vue"),
            name: "BuyDeal",
            meta: {
              title: "填写求购单",
              showFooter: true,
              showHeader: true,
            },
          },
          {
            path: "buyDetail",
            component: () => import("@/views/wantBuy/buyDetail.vue"),
            name: "BuyDetail",
            meta: {
              title: "求购详情",
              showFooter: true,
              showHeader: true,
            },
          },
        ],
      },
      {
        path: "info",
        component: () => import("@/views/info/index"),
        name: "Info",
        meta: {
          title: "信息中心",
          showFooter: true,
          showHeader: true,
        },
        children: [
          {
            path: "detail",
            component: () => import("@/views/info/detail"),
            name: "InfoDetail",
            meta: {
              title: "资讯详情",
              showFooter: true,
              showHeader: true,
            },
          },
        ],
      },
      {
        path: "finance",
        component: () => import("@/views/finance/index"),
        name: "Finance",
        meta: {
          title: "金融中心",
          showFooter: true,
          showHeader: true,
        },
      },
      {
        path: "about",
        component: () => import("@/views/about/index"),
        name: "About",
        meta: {
          title: "关于融鑫通",
          showFooter: true,
          showHeader: true,
        },
      },
      {
        path: "tradersCenter",
        component: () => import("@/views/tradersCenter/index.vue"),
        name: "TradersCenter",
        meta: {
          title: "贸易商中心",
          showFooter: true,
          showHeader: false,
        },
      },
      {
        path: "search",
        component: () => import("@/views/search/index.vue"),
        name: "Search",
        meta: {
          title: "搜索",
          showFooter: true,
          showHeader: true,
        }
      }
    ],
  },
];

const router = new VueRouter({
  routes,
});

export default router;
